import { ExpandMore as ExpandMoreIcon } from "../../components/icons";
import UILoader from "../UILoader";
import { createStylesheet } from "../../utils/styles";
import { UIGrid, UIMenuItem, UISelect, UIStack, UITableCell, UITableFooter, UITableRow, UITypography } from "..";
import UIButton from "../UIButton";

interface Props {
  hasMore: boolean | undefined;
  disabled?: boolean;
  onLoadMoreClick?: any;
  variant?: "text" | "contained" | "outlined";
  pagination?: boolean;
  rowCountOptions?: number[];
  rowCount?: number;
  onRowCountChange?: (size: number) => void;
  fetchedRowsCount: number;
  showFetchedRows?: boolean;
}

export const LoadMoreFooter = ({
  disabled,
  hasMore,
  onLoadMoreClick,
  variant = "outlined",
  rowCountOptions = [25, 50, 100, 250],
  pagination = false,
  rowCount,
  onRowCountChange,
  fetchedRowsCount,
  showFetchedRows = false,
}: Props) => {
  const classes = useStyles();

  return fetchedRowsCount > 0 ? (
    <UITableFooter>
      <UITableRow>
        <UITableCell className={classes.root}>
          <UIGrid
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
            container
          >
            <UIGrid>
              {showFetchedRows && (
                <UITypography variant="body2" color="textSecondary" paddingLeft={2}>
                  Showing {fetchedRowsCount} rows
                </UITypography>
              )}
            </UIGrid>
            <UIGrid>
              {hasMore ? (
                <UIStack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"center"}>
                  <UIButton
                    disabled={disabled}
                    startIcon={disabled ? null : <ExpandMoreIcon />}
                    onClick={onLoadMoreClick}
                    variant={variant}
                    color="primary"
                    data-cy="load_more"
                  >
                    {disabled ? <UILoader size={18} className={classes.isLoading} /> : "Load More"}
                  </UIButton>
                  {pagination && (
                    <UIStack direction="row" spacing={1} alignItems="center">
                      <UITypography variant="body2" color="textSecondary">
                        Rows:
                      </UITypography>
                      <UISelect
                        variant="outlined"
                        value={rowCount || rowCountOptions[0]}
                        size="small"
                        onChange={(event) => {
                          const newSize = Number(event.target.value);
                          onRowCountChange?.(newSize);
                        }}
                      >
                        {rowCountOptions.map((option) => (
                          <UIMenuItem value={option} key={`option-${option}`} data-cy={`option-${option}`}>
                            {option}
                          </UIMenuItem>
                        ))}
                      </UISelect>
                    </UIStack>
                  )}
                </UIStack>
              ) : (
                <UITypography variant="body2" color="textSecondary">
                  All rows have been loaded
                </UITypography>
              )}
            </UIGrid>
            <UIGrid />
          </UIGrid>
        </UITableCell>
      </UITableRow>
    </UITableFooter>
  ) : null;
};

const useStyles = createStylesheet((theme) => ({
  isLoading: {
    margin: "3px 38px",
  },
  root: {
    padding: theme.spacing(1),
  },
}));
